/* eslint-disable react-hooks/exhaustive-deps */

import { FC, useMemo } from 'react';
import { FilterOptions } from '../../reducers/filters.types';

type PriceOptions = {
    options: FilterOptions;
    priceOtherInt: number;
    keyPrefix: string;
};

export const ForSalePriceMinSelectOptions: FC<PriceOptions> = ({
    options,
    priceOtherInt,
    keyPrefix
}) =>
    useMemo(() => {
        const priceMaxInt = priceOtherInt;

        return (
            <>
                {options
                    ?.filter(
                        (priceMinOption) =>
                            priceMaxInt === 0 ||
                            priceMinOption === null ||
                            priceMaxInt >= parseInt(priceMinOption?.value)
                    )
                    ?.map((priceMinOption) => (
                        <option
                            key={`${keyPrefix}-${priceMinOption?.value}`}
                            value={priceMinOption?.value}
                        >
                            {priceMinOption?.label}
                        </option>
                    ))}
            </>
        );
    }, [priceOtherInt]);

export const ForSalePriceMaxSelectOptions: FC<PriceOptions> = ({
    options,
    priceOtherInt,
    keyPrefix
}) =>
    useMemo(() => {
        const priceMinInt = priceOtherInt;
        return (
            <>
                {options
                    ?.filter(
                        (priceMaxOption) =>
                            priceMaxOption === null ||
                            priceMaxOption.value === '0' ||
                            priceMinInt <= parseInt(priceMaxOption?.value)
                    )
                    ?.map((priceMaxOption) => (
                        <option
                            key={`${keyPrefix}-${priceMaxOption?.value}`}
                            value={priceMaxOption?.value}
                        >
                            {priceMaxOption?.label}
                        </option>
                    ))}
            </>
        );
    }, [priceOtherInt]);

export const ToRentPriceMinSelectOptions: FC<PriceOptions> = ({
    options,
    priceOtherInt,
    keyPrefix
}) =>
    useMemo(() => {
        const priceMaxInt = priceOtherInt;

        return (
            <>
                {options
                    ?.filter(
                        (priceMinOption) =>
                            priceOtherInt === 0 ||
                            priceMinOption === null ||
                            priceMaxInt >= parseInt(priceMinOption?.value)
                    )
                    ?.map((priceMinOption) => (
                        <option
                            key={`${keyPrefix}-${priceMinOption?.value}`}
                            value={priceMinOption?.value}
                        >
                            {priceMinOption?.label}
                        </option>
                    ))}
            </>
        );
    }, [priceOtherInt]);

export const ToRentPriceMaxSelectOptions: FC<PriceOptions> = ({
    options,
    priceOtherInt,
    keyPrefix
}) =>
    useMemo(() => {
        const priceMinInt = priceOtherInt;

        return (
            <>
                {options
                    ?.filter(
                        (priceMaxOption) =>
                            priceMaxOption === null ||
                            priceMaxOption.value === '0' ||
                            priceMinInt <= parseInt(priceMaxOption?.value)
                    )
                    ?.map((priceMaxOption) => (
                        <option
                            key={`${keyPrefix}-${priceMaxOption?.value}`}
                            value={priceMaxOption?.value}
                        >
                            {priceMaxOption?.label}
                        </option>
                    ))}
            </>
        );
    }, [priceOtherInt]);
